/**
 * Экраны, нужные до загрузки остального приложения (блокировка, фатальная ошибка) и общие константы.
 * Вынесены из Profile, чтобы страницы профиля и мастер публикации загружались отдельными чанками.
 */
import type { Locale } from '@qm/shared';
import { useTranslation } from 'react-i18next';
import { Screen } from '../components/layout';
import { EmptyState, ErrorState } from '../components/ui';
import { useMe } from '../lib/auth';

export const LANGUAGE_NAMES: Record<Locale, string> = { uz: "O'zbekcha", kaa: 'Qaraqalpaqsha', ru: 'Русский' };

export function BlockedPage() {
  const { t } = useTranslation();
  const me = useMe();
  return (
    <Screen noNav>
      <EmptyState icon="shield" title={t('blocked.title')} text={t('blocked.text')} />
      {me.blockedReason ? <p className="center tiny muted">{me.blockedReason}</p> : null}
    </Screen>
  );
}

export function FatalScreen({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  return (
    <Screen noNav>
      <ErrorState error={error} onRetry={onRetry} />
    </Screen>
  );
}
